import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="cursor-pointer transition-colors hover:text-accent-700"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}